export default __webpack_public_path__ + "static/media/graphTime.29aa8934.png";